if (!customElements.get('sticker-price-calculator')) {
  class StickerPriceCalculator extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.currency = this.dataset.currency || 'USD';
      this.showSavings = this.dataset.showSavings === '1';
      this.tiers = [];
      this.qty = 1;

      this.ladderEl = this.querySelector('[data-sp-ladder]');
      this.eachEl = this.querySelector('[data-sp-each]');
      this.totalEl = this.querySelector('[data-sp-total]');
      this.savingsEl = this.querySelector('[data-sp-savings]');
      this.savingsTextEl = this.querySelector('[data-sp-savings-text]');
      this.upsellEl = this.querySelector('[data-sp-upsell]');
      this.upsellTextEl = this.querySelector('[data-sp-upsell-text]');
    }

    connectedCallback() {
      const tierJson = this.querySelector('[data-sp-tiers]');
      try {
        this.tiers = JSON.parse((tierJson && tierJson.textContent) || '[]');
      } catch (err) {
        this.tiers = [];
      }

      this.qtyInput = document.getElementById(`Quantity-${this.sectionId}`);
      if (this.qtyInput) {
        this.qty = parseInt(this.qtyInput.value, 10) || 1;
        ['change', 'input'].forEach((evt) => this.qtyInput.addEventListener(evt, () => {
          this.qty = parseInt(this.qtyInput.value, 10) || 1;
          this.render();
          this.updateMobileBar();
        }));
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
          this.qty = parseInt(this.qtyInput && this.qtyInput.value, 10) || 1;
          this.render();
          this.updateMobileBar();
        });
      }

      this.setupMobileAtcObserver();
      this.render();
      this.updateMobileBar();
    }

    findTier(qty) {
      return this.tiers.find((t) => qty >= t.min && (t.max === null || qty <= t.max)) || this.tiers[0];
    }

    findNextTier(qty) {
      const idx = this.tiers.findIndex((t) => qty >= t.min && (t.max === null || qty <= t.max));
      return idx >= 0 && idx < this.tiers.length - 1 ? this.tiers[idx + 1] : null;
    }

    formatMoney(cents) {
      const v = cents / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency }).format(v);
      } catch (err) {
        return `$${v.toFixed(2)}`;
      }
    }

    render() {
      if (!this.tiers.length) return;

      const tier = this.findTier(this.qty);
      const baseCents = this.tiers[0].price_cents;
      const tierCents = tier.price_cents;
      const subtotal = baseCents * this.qty;
      const discountedTotal = tierCents * this.qty;
      const savings = subtotal - discountedTotal;

      this.eachEl.textContent = `${this.formatMoney(tierCents)} / sticker`;
      this.totalEl.textContent = this.formatMoney(this.showSavings ? discountedTotal : subtotal);

      if (this.showSavings && savings > 0 && this.savingsEl) {
        const pct = Math.round((1 - tierCents / baseCents) * 100);
        this.savingsTextEl.textContent = `${this.formatMoney(baseCents)} × ${this.qty} — you save ${this.formatMoney(savings)} (${pct}% off)`;
        this.savingsEl.hidden = false;
      } else if (this.savingsEl) {
        this.savingsEl.hidden = true;
      }

      const next = this.findNextTier(this.qty);
      if (next && this.upsellEl) {
        const needed = next.min - this.qty;
        const projectedSavings = (baseCents - next.price_cents) * next.min;
        this.upsellTextEl.textContent = `Add ${needed} more to drop to ${this.formatMoney(next.price_cents)}/sticker — save ${this.formatMoney(projectedSavings)} total.`;
        this.upsellEl.hidden = false;
      } else if (this.upsellEl) {
        this.upsellEl.hidden = true;
      }

      this.renderLadder(tier);
    }

    renderLadder(activeTier) {
      if (!this.ladderEl) return;
      const html = this.tiers.map((t) => {
        const isActive = t.min === activeTier.min;
        const label = t.max === null ? `${t.min}+` : `${t.min}${t.max > t.min ? '–' + t.max : ''}`;
        const each = this.formatMoney(t.price_cents);
        return `
          <div class="sp-tier__pill${isActive ? ' sp-tier__pill--active' : ''}">
            <span class="sp-tier__pill-qty">${label}</span>
            <span class="sp-tier__pill-each">${each}</span>
          </div>
        `;
      }).join('');
      this.ladderEl.innerHTML = html;
    }

    updateMobileBar() {
      const bar = document.getElementById(`sp-mobile-atc-${this.sectionId}`);
      if (!bar) return;
      const totalEl = bar.querySelector('[data-sp-mobile-total]');
      if (totalEl && this.tiers.length) {
        const tier = this.findTier(this.qty);
        totalEl.textContent = this.formatMoney(tier.price_cents * this.qty);
      }
    }

    setupMobileAtcObserver() {
      const buyButtons = document.querySelector(`#MainProduct-${this.sectionId} .sp-buy product-form`);
      const bar = document.getElementById(`sp-mobile-atc-${this.sectionId}`);
      if (!buyButtons || !bar) return;

      const cta = bar.querySelector('[data-sp-mobile-cta]');
      if (cta) {
        cta.addEventListener('click', () => {
          const form = document.getElementById(cta.dataset.formId);
          if (form && form.requestSubmit) form.requestSubmit();
          else if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }

      const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!isMobile()) {
            bar.hidden = true;
            return;
          }
          bar.hidden = entry.isIntersecting;
        });
      }, { threshold: 0.1 });
      observer.observe(buyButtons);
    }
  }

  customElements.define('sticker-price-calculator', StickerPriceCalculator);
}
